import { Component } from '@angular/core';
import { HttpService } from 'src/app/http.service';

// Panel approval screen for agent "Buy Member Level" bank-transfer orders.
// Agents who choose Manual Bank Transfer on the sub-agent registration page submit
// a PENDING order (no sub-agent created yet). The admin verifies the bank transfer
// here and APPROVES — which creates the sub-agent, assigns the purchased member
// level, and grants the configured wallet credit — or REJECTS with a reason.
@Component({
  selector: 'app-agent-level-purchase',
  templateUrl: './agent-level-purchase.component.html',
  styleUrls: ['./agent-level-purchase.component.scss']
})
export class AgentLevelPurchaseComponent {

  public requests: any = [];
  public status: string = 'pending';
  public is_loading: boolean = false;

  constructor(private http: HttpService) {
    this.getRequests();
  }

  public async getRequests(status: string = 'pending'): Promise<void> {
    this.is_loading = true;
    this.status = status;
    let rtn: any = await this.http.post("/admin/agent-level-purchase/get", { status: this.status });
    this.requests = rtn || [];
    this.requests.forEach((r: any) => { r.action_status = 'paid'; });
    this.is_loading = false;
  }

  async updateRequest(request: any) {
    if (request.action_status === 'rejected' && !request.remark) {
      this.http.toast("Please enter a reason for rejection.", "error");
      return;
    }

    let rtn: any = await this.http.post("/admin/agent-level-purchase/update", {
      uuid: request.uuid,
      status: request.action_status,
      remark: request.remark
    });

    if (rtn.status) {
      this.getRequests(this.status);
    }
    if (rtn.message) {
      this.http.toast(rtn.message, rtn.status ? "success" : "error");
    }
  }
}
